import React, { useState } from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

import contact_paper from "../assets/duck-images/contact-paper-final.webp"
import contact_paper_mob from "../assets/duck-images/contact-paper-final-mob.webp"

import { addContact } from '../components/Firebase/Contact'

function Contact({ ConnectWalletFunc, state, setState, disconnectWallet }) {
    const [fName, setFname] = useState("");
    const [lName, setLname] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [twitter, setTwitter] = useState("");


    async function handleSubmit(e) {
        e.preventDefault()
        
        if (fName === "" || lName === "" || email === "" || message === "" || twitter === "") {
            alert("Please Fill out All Fields")
        }
        
        else {
            const res = await addContact({
                Fname: fName,
                Lname: lName,
                Email: email,
                Message: message,
                Twitter: twitter
            })
                .then((data => {
                    // console.log(data);
                }))
                .catch((err => {
                    console.log(err);
                }))
        }
    }


    return (
        <>
            <section className='section-contact'>
                <div className="glass">
                    <Navbar ConnectWalletFunc={ConnectWalletFunc} isConnect={state} setIsConnect={setState} disconnectWallet={disconnectWallet} />
                </div>
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="content">
                            <h1>CONTACT US</h1>
                            {/* <p>If you're interested in collaborating with Duckduckgoose, please email us at <b>duckduckgoosegame@gmail.com</b></p> */}
                            <p>If you're interested in collaborating with Duckduckgoose, please contact us</p>
                        </div>
                    </div>
                    <div className="">
                        <div className="form_image">
                            <img src={contact_paper} alt="image" className='img-fluid contact_paper' />
                            <img src={contact_paper_mob} alt="image" className='img-fluid d-none contact_paper_mob' />
                            <div className="contact-form mb-5">
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <label>NAME <span>*</span> </label>
                                    <div className="form-group mb-4 mt-2 d-flex name_group">
                                        <input type="text" placeholder='First Name' value={fName} onChange={(e) => setFname(e.target.value)} className='form-control mx-1' required />
                                        <input type="text" placeholder='Last Name' value={lName} onChange={(e) => setLname(e.target.value)} className='form-control mx-1' required />
                                    </div>
                                    <label>EMAIL <span>*</span> </label>
                                    <div className="form-group mb-4 mt-2">
                                        <input type="email" placeholder='Your email' value={email} onChange={(e) => setEmail(e.target.value)} className='form-control' required />
                                    </div>
                                    <label>MESSAGE <span>*</span> </label>
                                    <div className="form-group mb-4 mt-2">
                                        <textarea cols="30" rows="2" placeholder='Type Here...' value={message} onChange={(e) => setMessage(e.target.value)} className='form-control' required ></textarea>
                                    </div>
                                    <label>TWITTER</label>
                                    <div className="form-group mb-4 mt-2">
                                        <input type="text" placeholder='@username' value={twitter} onChange={(e) => setTwitter(e.target.value)} className='form-control' required />
                                    </div>
                                    <div className="button mb-3">
                                        <button className='btn' type='submit' style={{ paddingBottom: "12px", borderRadius: "10px" }}>Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </section>
        </>
    )
}

export default Contact
